import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditHQFetchNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditHQFetchNode.id)) {
            newEdges.push(edge);
        }
    }

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditHQFetchNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }

    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description: 'Location of fetch data',
            default: 'default'
        },
        entity_or_action: {
            title: 'Entity or Action',
            type: 'string',
            enum: [
                'Entity',
                'NokNok Action'
            ],
            default: 'Entity'
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to store fetch response',
            default: 'default'
        },
        add_output_to_message: {
            title: 'Add Output To Messages',
            type: 'boolean',
            default: false,
            description: 'Store output as a message to keep in the message history as well as Data store',
        }
    },
    allOf: [
        {
            if: {
                properties: {
                    entity_or_action: {
                        const: 'Entity'
                    }
                }
            },
            then: {
                properties: {
                    entity_data: {
                        title: '',
                        type: 'object',
                        properties: {
                            entity_type: {
                                title: 'Entity Type',
                                type: 'string',
                                enum: [
                                    'Customer (not available yet)',
                                    'Company',
                                    'Website',
                                    'Url',
                                    'Contacts',
                                    'Emails',
                                    'Telephone Numbers',
                                    'Address',
                                    'Social Media',
                                    'Employees',
                                    'Persona',
                                ],
                                default: 'Customer (not available yet)'
                            },
                        },
                        allOf: [
                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Customer (not available yet)'
                                        }
                                    }
                                },
                                then: {
                                    properties: {

                                    }
                                }
                            },
                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Persona'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        persona__options: {
                                            title: 'Persona GET Option',
                                            type: 'string',
                                            // With Nok Website: the persona plus the company it
                                            // writes as, for the Mystery Shopper drafting workflow.
                                            enum: [
                                                'By Persona ID',
                                                'By Persona ID With Nok Website',
                                                'By Nok Website ID',
                                            ]
                                        },
                                    }
                                }
                            },
                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Company'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        company__options: {
                                            title: 'Company GET Option',
                                            type: 'string',
                                            // With Industry: the company's name, size and
                                            // industry name, for the Mystery Shopper workflows.
                                            enum: [
                                                'By Company ID',
                                                'By Company ID With Industry',
                                                'By Company Name',
                                            ]
                                        },
                                    }
                                }
                            },

                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Website'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                       website__options: {
                                           title: 'Website GET Option',
                                           type: 'string',
                                           enum: [
                                               'By Website ID',
                                               'By Website Name',
                                               'By Website URL'
                                           ]
                                        },
                                    }
                                }
                            },

                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Url'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        url__options: {
                                            title: 'Url GET Option',
                                            type: 'string',
                                            enum: [
                                                'By URL ID',
                                                'By Linked Website ID',
                                                'By URL Path'
                                            ]
                                        },
                                    }
                                }
                            },

                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Contacts'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        contacts__options: {
                                            title: 'Contact GET Option',
                                            type: 'string',
                                            enum: [
                                                'By Contact ID',
                                                'By Contact Name',
                                            ]
                                        },
                                    }
                                }
                            },

                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Emails'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        email__options: {
                                            title: 'Email GET Option',
                                            type: 'string',
                                            enum: [
                                                'By Email ID',
                                                'By Email',
                                            ]
                                        },
                                    }
                                }
                            },

                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Telephone Numbers'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        telephone_numbers__options: {
                                            title: 'Telephone Number GET Option',
                                            type: 'string',
                                            enum: [
                                                'By Telephone Number ID',
                                                'By Company ID',
                                            ]
                                        },
                                    }
                                }
                            },

                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Address'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        address__options: {
                                            title: 'Address GET Option',
                                            type: 'string',
                                            enum: [
                                                'By Address ID',
                                                'By Company ID',
                                                'By Line One',
                                                'By Postcode'
                                            ]
                                        },
                                    }
                                }
                            },

                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Social Media'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        social_media__options: {
                                            title: 'Social Media GET Option',
                                            type: 'string',
                                            enum: [
                                                'By Social Media ID',
                                                'By Company ID',
                                                'By Contact ID',
                                                'By Social Media Platform',
                                            ]
                                        },
                                    }
                                }
                            },

                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Employees'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        employee__options: {
                                            title: 'Employee GET Option',
                                            type: 'string',
                                            enum: [
                                                'By Employee ID',
                                                'By Company ID',
                                                'By Contact ID',
                                            ]
                                        },
                                    }
                                }
                            },
                        ]
                    }
                }
            }
        },

        {
            if: {
                properties: {
                    entity_or_action: {
                        const: 'NokNok Action'
                    }
                }
            },
            then: {
                properties: {
                    custom_action: {
                        title: 'NokNok Action',
                        type: 'string',
                        enum: [
                            'Fetch Next Website To Scrape',
                            'Fetch Random Nok',
                            'Request EmailFinder Status',
                            'Do Something New',
                            'Do All The Things',
                        ],
                        default: 'Fetch Next Website To Scrape'
                    }
                },
            }
        },
        {
            if: {
                properties: {
                    data_management: {
                        const: 'messages'
                    }
                }
            },
            then: {
                properties: {
                    add_output_to_message: {
                        readOnly: true,
                    }
                }
            }
        }



    ]
}

export const nodeDescription: string = "This node is used to fetch data from HQ.\n";
